import { Link } from 'react-router-dom';

const CaresAuthenticatedFooter = () => {
  return (
    <footer className="footer mt-auto py-3 bg-white text-center">
      <div className="container">
        <span className="text-muted">
          Copyright © <span id="year">{new Date().getFullYear()}</span>{' '}
          <Link to="/" className="text-dark fw-medium">
            CARES
          </Link>{' '}
          Platform
        </span>
      </div>
    </footer>
  );
};

export default CaresAuthenticatedFooter;
